import {post,get} from '../libs/ajax.js'

export default {
    // 角色列表
    getRoleList: (data, options) => {
        return get('/role/list', data, options)
    },
    // 获取角色类型
    getRoleType: (data, options) => {
        return get('/role/get_role_type', data, options)
    },
    // 添加角色-获取角色配置项
    getAddRoleConfig: (data, options) => {
        return get('/role/get_add_role_config', data, options)
    },
    // 添加角色-提交
    addRole: (data, options) => {
        return post('/role/add', data, options)
    },
    // 获取角色信息
    getRoleInfo: (data, options) => {
        return get('/role/get_role_info', data, options)
    },
    // 删除角色
    deleteRole: (data, options) => {
        return post('/role/del', data, options)
    },
    // 编辑角色
    editRole: (data, options) => {
        return post('/role/edit', data, options)
    },
    // 获取所有角色-排序用
    getAllRoleList: (data, options) => {
        return post('/role/all_role', data, options)
    },
    // 角色列表排序
    setRoleOrder: (data, options) => {
        return post('/role/set_order', data, options)
    },
    // 角色批量编辑
    batchEditRole: (data, options) => {
        return post('/role/bulk_edit', data, options)
    },
    // 复制角色
    getCopyRoleInfo: (data, options) => {
        return get('/role/copy_role_info', data, options)
    },
}
